export const isEmptyObject = (obj: object) => Object.keys(obj).length === 0

export const getEnumKeyByEnumValue = <E>(myEnum: object, key: E) =>
  Object.keys(myEnum)[Object.values(myEnum).indexOf(key)]

// Converts all keys´s first letters to lowercase
export const convertObjectKeysToLowercase = (obj: unknown): unknown => {
  if (Array.isArray(obj)) {
    // If it's an array, recursively process each element in the array
    return obj.map((item) => convertObjectKeysToLowercase(item))
  } else if (typeof obj === 'object' && obj !== null) {
    // If it's an object, recursively process each key-value pair
    const record = obj as Record<string, unknown>
    const newObj: Record<string, unknown> = {}
    for (const key in record) {
      if (Object.prototype.hasOwnProperty.call(record, key)) {
        const newKey = key.charAt(0).toLowerCase() + key.slice(1)
        newObj[newKey] = convertObjectKeysToLowercase(record[key])
      }
    }
    return newObj
  } else {
    // If it's neither an object nor an array, return it as is
    return obj
  }
}
